<template>
  <PgDialogSelectTable
    ref="domRef"
    :idPrefix="idPrefix"
    :value="value"
    :column="column"
    :method="requestMethod"
    :paramater="requestParamNew"
    :placeholder="placeholder1"
    :url="url"
    :title="title"
    :showCode="showCodeKey"
    :showName="inputKey"
    :disabled="disabled || readonly || setDisabled"
    :valueIsObj="valueIsObject"
    :selectionKey="valueKey"
    :requestDataKey="requestDataKey"
    :keywordKey="nowKeywordKey"
    :beforValueAction="beforValueAction"
    :store="store"
    :pageSize="pageSize"
    :defaultValuePolicy="defaultValuePolicy"
    :appendToBody="appendToBody"
    v-on="$listeners"
  ></PgDialogSelectTable>
</template>
<script>
export default {
  name: 'inputSelectOfModalTable',
  inheritAttrs: false,
}
</script>
<script setup>
import { PgDialogSelectTable } from 'pangu-components-plus'
import { computed, watch, ref, onUnmounted } from 'vue'
import * as scanUtils from '../../../static/js/scanUtils.js'

const props = defineProps({
  idPrefix: {
    type: String,
    default: 'inputSelectOfModalTable',
  },
  value: {
    type: [String, Object],
    default: () => {},
  },
  tableColumnDef: {
    type: Array,
    default: () => {
      return [
        {
          prop: 'code',
          label: '编码',
          width: '120',
        },
        {
          prop: 'name',
          label: '名称',
        },
      ]
    },
  },
  requestMethod: {
    type: String,
    default: 'get',
  },
  requestParam: {
    type: [String, Object],
    default: null,
  },
  //改名为placeholder1是因为原来有很多配置了placeholder的不满足之后的组件，所以默认都是编码/名称，如果有特殊的在通过placeholder1进行修改
  placeholder1: {
    type: String,
    default: '编码/名称',
  },
  url: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '请选择',
  },
  showCodeKey: {
    type: String,
    default: 'code',
  },
  inputKey: {
    type: String,
    default: 'name',
  },
  parentValue: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  store: {
    type: Object,
    default: null,
  },
  // 提交给后台的数据是否为obj
  valueIsObject: {
    type: Boolean,
    default: true,
  },
  // input框显示的值
  showInputValueKey: {
    type: String,
    default: 'name',
  },
  // 提交给后台的值
  valueKey: {
    type: String,
    default: 'code',
  },
  requestDataKey: String,
  //[侧滑-表格-数据请求]是否将搜索字段放入parameters内
  isParameters: {
    type: Boolean,
    default: false,
  },
  //[侧滑-表格-搜索框查询]远程请求的参数.支持path方式。比如：parameters.keyword
  searchKey: {
    type: String,
    default: 'keyword',
  },
  //每页获取数据条数，为0或不存在时表示不使用分页查询
  pageSize: {
    type: Number,
    default: 20,
  },
  //为了兼容扫码组件的处理逻辑
  goodsId: {
    type: String,
    default: null,
  },
  beforValueAction: Object,
  defaultValuePolicy: String,
  relactionCode: String,
  appendToBody: Boolean,
})
const setDisabled = ref(false)
const column = computed(() =>
  props.tableColumnDef.map((im) => ({ property: im.prop, label: im.label, width: im.width }))
)
const nowKeywordKey = computed(() =>
  props.isParameters ? `parameters.${props.searchKey}` : props.searchKey
)
const domRef = ref(null)

const requestParamNew = computed(() =>
  props.goodsId
    ? Object.assign(props.requestParam, { parameters: { goodsId: props.goodsId } })
    : props.requestParam
)
const updateFormItemDisabled = (items = [], relactionCodes) => {
  console.log('联动更新表单项 items: ', items)
  if (
    Object.prototype.toString.call(relactionCodes) === '[object Array]' &&
    relactionCodes.includes(props.relactionCode) &&
    items &&
    Object.prototype.toString.call(items) === '[object Array]'
  ) {
    setDisabled.value = items.length === 0
  }
}
const initListener = () => {
  scanUtils.$bus.$on('registrationSelection.formData.items.disabled', updateFormItemDisabled)
}
if (props?.relactionCode) {
  initListener()
}

watch(
  () => props.parentValue,
  () => {
    domRef.value.setValue(null)
  }
)

onUnmounted(() => {
  // 移除事件监听
  scanUtils.$bus.$off('registrationSelection.formData.items.disabled', updateFormItemDisabled)
})
</script>
